import classnames from "classnames";
import { ModalDeleteIcon } from "components/assets/Icons";
import Button, { SIZE as VIEW, COLOR } from "components/Button";
import styles from "./DeleteConfirmModal.module.scss";

const DeleteConfirmModal = ({
  isOpen,
  rule,
  onConfirm,
  onClose,
  loading,
  error
}) => {
  if (!rule) return null;

  const handleConfirm = (e) => {
    e.preventDefault();
    if (onConfirm && !loading) {
      onConfirm(rule.id);
    }
  };

  return (
    <div className={classnames(styles.content, styles.delete_content)}>
      <ModalDeleteIcon />
      <h2 className={styles.title}>Delete Rule</h2>
      <p className={styles.description}>
        Do you want to delete "{rule.name || `Rule #${rule.id}`}"? This process cannot be undone.
      </p>
      {error && (
        <div className={styles.error} role="alert">
          {error}
        </div>
      )}
      <div className={styles.group}>
        <Button size={VIEW.MIDDLE} color={COLOR.NONE} onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button size={VIEW.MIDDLE} onClick={handleConfirm} disabled={loading}>
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;